import BusinessFinancePage from './finance-business';

/**
 * ⚡ SALES MACHINE ROUTER
 * There is no more Professional vs Business distinction in the UI.
 * All owners see the unified sales performance dashboard.
 */
export const SalesRouter = () => {
  return <BusinessFinancePage />;
};
